import { useEffect } from 'react';

import { animate, motion, useMotionValue, useTransform } from 'motion/react';

const NumberMotion = ({ increaseto }) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, value => Math.round(value));

  useEffect(() => {
    const controls = animate(count, increaseto, { duration: 0.5 });
    return () => controls.stop();
  }, [increaseto]);

  return <motion.span>{rounded}</motion.span>;
};

export default NumberMotion;
